import React from 'react'
import { Widget } from 'features/types'
import { TopicNotSelectedGuard } from 'components/widget/share/guards'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SocialWebIndexWidget as SocialWebIndexWidgetType } from 'schemas/SocialWebIndexWidgetSchema'
import { getLabel } from 'utils/widgetTypeUtil'
import IndexWidgetDataGuards from '../share/guards/IndexWidgetDataGuards'
import RunSearchEffect from '../share/RunSearchEffect'
import IndexWidgetBubbleChartGuard from '../share/guards/IndexWidgetBubbleChartGuard'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'
import InsightModal from '../share/InsightModal'
import IndexTable from '../share/Table'

const SocialWebIndexWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebIndexWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <IndexWidgetBubbleChartGuard widgetId={widgetId}>
          <RunSearchEffect widgetId={widgetId}>
            <IndexWidgetDataGuards widgetId={widgetId}>
              <IndexTable widgetId={widgetId} onRowClick={onClick} />
            </IndexWidgetDataGuards>
          </RunSearchEffect>
        </IndexWidgetBubbleChartGuard>
      </TopicNotSelectedGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={widgetSetting?.countType}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
        viewOption={widgetSetting?.viewOption}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebIndexWidget
